import React from 'react';

import classNames from 'classnames/bind';
import styles from './AdminPageTitle.css';
const cx = classNames.bind(styles);

const AdminPageTitle = ({ title, children, type, ...rest }) => (
  <div className={cx('admin-page-title-box', { small: rest.small }, { 'table-title': type === 'table' })}>
    <div className={cx('page-title')}>{title}</div>
    {children && <div className={cx('page-func')}>{children}</div>}
  </div>
);

export default AdminPageTitle;



// WEBPACK FOOTER //
// ./src/script/components/admin/common/AdminPageTitle.js